import { useSelector } from 'react-redux';
import { NoRatesFound } from 'shared/components';
import { resultLimit } from '../config';
import ResultBlock from './ResultBlock';

const ResultsList = () => {
  const { input, output: { products }} = useSelector(state => state);
  const resultItems = input.showAll ? products : products.slice(0, resultLimit);
  return products.length < 1 ? (
    <NoRatesFound css={{ marginTop: 48 }} />
  ) : (
    resultItems.map(result => {
      const isActive = input.label_id === result.label_id;
      return (
        <ResultBlock
          key={result.label_id}
          result={result}
          isActive={isActive}
          hideRadioCheck={resultItems.length <= 1}
        />
      );
    })
  );
};

export default ResultsList;
